import constants from '@/app-configs/constants'

export default [
  {
    path: '/email-templates',
    name: 'email-templates',
    component: () => import('@/views/templates/EmailTemplate.vue'),
    meta: {
      pageTitle: 'DEBTIA_EMAIL_TEMPLATE',
      breadcrumb: [
        {
          text: 'DEBTIA_EMAIL_TEMPLATE',
          active: true,
        },
      ],
      action: constants.action.permissionEmailTemplateView,
      resource: constants.resource.emailTemplate,
    },
  },
  {
    path: '/sms-templates',
    name: 'sms-templates',
    component: () => import('@/views/templates/SmsTemplate.vue'),
    meta: {
      pageTitle: 'DEBTIA_SMS_TEMPLATE',
      breadcrumb: [
        {
          text: 'DEBTIA_SMS_TEMPLATE',
          active: true,
        },
      ],
      action: constants.action.permissionSMSTemplateView,
      resource: constants.resource.smsTemplate,
    },
  },
]
